import React from "react";

/** Live-presence marker: a pulsing dot, optionally with an active-user
 *  count where there's room (the All-models list). */
export const LiveIndicator: React.FC<{
  count: number;
  showCount?: boolean;
}> = ({ count, showCount = false }) => {
  if (count <= 0) return null;
  return (
    <span
      className="inline-flex items-center gap-1 shrink-0"
      style={{ color: "var(--color-success)" }}
    >
      <span className="live-dot" />
      {showCount && (
        <span className="text-small">
          {count} active {count === 1 ? "user" : "users"}
        </span>
      )}
    </span>
  );
};
